import { KeyEvent, useKeyPress } from '@qfa/react-components';
import { useEffect } from 'react';

export const useHotKey = ({
  key,
  shift = false,
  ctrl = true,
  callback,
  alt = false,
}: {
  key: string;
  shift?: boolean;
  ctrl?: boolean;
  alt?: boolean;
  callback: () => void;
}) => {
  const onSaveHotKey = (event: KeyEvent<HTMLElement>) => {
    event.preventDefault();
    callback();
  };
  const onKeyDown = useKeyPress({ key, shift, ctrl, alt, callback: onSaveHotKey });
  useEffect(() => {
    window.addEventListener('keydown', onKeyDown);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [onKeyDown]);
};
